const { default: axiosIns } = require('@/libs/axios')

const EmailsService = {
  // GET - EmailApiController
  async getEmails() {
    return axiosIns.get('admin/emails').then(response => response.data)
  },
  async getEmail(emailId) {
    return axiosIns.get(`admin/emails/${emailId}`).then(response => response.data)
  },
  // PUT - EmailApiController
  async updateEmailTemplate(model) {
    return axiosIns.put(`admin/emails/${model.id}`, model).then(response => response.data)
  },
  // POST - EmailApiController
  async sendEmail(properties, email, id) {
    return axiosIns.post('admin/emails', properties, {
      params: {
        email,
        id,
      },
    }).then(response => response.data)
  },
}

export default EmailsService
